import TeamPage from "@/features/profile/components/TeamPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/team/")({
    component: TeamPage,
});
